import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import Image from '~/components/blocks/core/Image';

const ImageBlock = ({
    mediaItem: {
        node: { altText, localFile }
    },
    attrs: {
        align,
        anchor,
        url,
        width,
        height,
        caption,
        className,
        scale,
        aspectRatio,
        href,
        linkTarget
    }
}) => (
    <Image
        {...{
            align,
            anchor,
            localFile,
            url,
            caption,
            className,
            scale,
            altText,
            aspectRatio,
            href,
            linkTarget
        }}
        width={width && width !== 'auto' ? parseInt(width) : null}
        height={height && height !== 'auto' ? parseInt(height) : null}
    />
);

ImageBlock.propTypes = {
    mediaItem: PropTypes.shape({
        node: PropTypes.shape({
            altText: PropTypes.string,
            localFile: PropTypes.shape({
                childImageSharp: PropTypes.object.isRequired
            }).isRequired
        }).isRequired
    }).isRequired,
    attrs: PropTypes.shape({
        align: PropTypes.string,
        anchor: PropTypes.string,
        url: PropTypes.string.isRequired,
        width: PropTypes.string,
        height: PropTypes.string,
        scale: PropTypes.string,
        aspectRatio: PropTypes.string,
        href: PropTypes.string,
        linkTarget: PropTypes.string
    }).isRequired
};

export default ImageBlock;

export const fragment = graphql`
    fragment ImageBlockFragment on WpCoreImageBlock {
        name
        mediaItem {
            node {
                altText
                localFile {
                    childImageSharp {
                        gatsbyImageData
                    }
                }
            }
        }
        attrs: attributes {
            ... on WpCoreImageBlockAttributes {
                align
                anchor
                url
                width
                height
                caption
                className
                scale
                aspectRatio
                href
                linkTarget
            }
        }
    }
`;

export const exampleData = [
    {
        variant: 'Aligned Center With Caption',
        props: {
            name: 'core/image',
            mediaItem: {
                node: {
                    localFile: {
                        childImageSharp: {}
                    }
                }
            },
            attrs: {
                align: 'center',
                caption:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                url: 'https://picsum.photos/850/600'
            }
        }
    }
];
